import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgPanelLeftSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M9 1L2 8L9 15M14 1L7 8L14 15"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgPanelLeftSmall.displayName = 'SvgPanelLeftSmall';
const PanelLeftSmall = withForgeIconProps(SvgPanelLeftSmall, {
  name: 'PanelLeft',
  usage: 'Use to open a panel to the left.',
  related: 'flyout, pane',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default PanelLeftSmall;
